import callApi from "./callApi";
import callPengaturanLaporan from "./callPengaturanLaporan";

const actions = {
  ...callApi,
  ...callPengaturanLaporan,
  setMenu: ({ commit }, payload) => {
    commit("setSubMenu", payload);
  },
  setSubTitle: ({ commit }, payload) => {
    commit("setSubTitle", payload);
  },
  updateEpayment: ({ commit }, payload) => {
    commit("updateEpayment", payload);
  },
  resetSettingEpayment: ({ commit }) => {
    commit("updateEpayment", { key: "masa_aktif_emoney", val: "" });
    commit("updateEpayment", { key: "tipe_perpanjangan_masa_aktif_emoney", val: "" });
    commit("updateEpayment", { key: "tipe_saldo_expired_emoney", val: "" });
  },
  setCustomerAmbilDanLunasi: ({ commit }, payload) => {
    commit("CustomerAmbilDanLunasi", payload);
  },
};

export default actions;
